import { ChatCloseIcon, ChatFileIcon } from '../../../assets/svg';
import { lightTheme } from '../../../styles/theme';
import { formatBytes } from '../helpers/chatFormat';
import { StagedAttachment } from '../hooks/useChatAttachments';
import {
  Chip,
  Meta,
  ProgressBar,
  RemoveButton,
  StagedRow,
  Thumb,
} from './StagedAttachments.styled';

export { HiddenFileInput } from './StagedAttachments.styled';

/** What a file with no name of its own is called in the chip. */
const typeLabel: Record<StagedAttachment['type'], string> = {
  image: 'Photo',
  video: 'Video',
  audio: 'Voice message',
  file: 'PDF',
};

/** The row of files waiting above the composer while they upload. */
export const StagedAttachments = ({
  staged,
  onRemove,
}: {
  staged: StagedAttachment[];
  onRemove: (key: string) => void;
}) => {
  if (staged.length === 0) return null;

  return (
    <StagedRow>
      {staged.map((item) => (
        <Chip key={item.key} $failed={item.failed}>
          <Thumb>
            {item.previewUrl ? (
              <img src={item.previewUrl} alt="" />
            ) : (
              <ChatFileIcon
                color={item.failed ? lightTheme.primary : lightTheme.darkGray}
              />
            )}
          </Thumb>

          <Meta>
            <span>{item.name || typeLabel[item.type]}</span>
            <span>
              {item.failed ? 'Upload failed' : formatBytes(item.size)}
            </span>
          </Meta>

          <RemoveButton
            type="button"
            aria-label={`Remove ${item.name}`}
            onClick={() => onRemove(item.key)}
          >
            <ChatCloseIcon />
          </RemoveButton>

          {!item.attachmentId && !item.failed && (
            <ProgressBar $value={item.progress} />
          )}
        </Chip>
      ))}
    </StagedRow>
  );
};
